import React from 'react';
import './PDFContentStep.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamationTriangle, faImage, faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';

const PDFContentStep = ({ 
    catalog,
    coverType,
    onCoverTypeChange,
    showPrices,
    onShowPricesChange,
    showDescriptions,
    onShowDescriptionsChange,
    showCodes,
    onShowCodesChange,
    showContactPage,
    onShowContactPageChange,
    removeBackgrounds,
    onRemoveBackgroundsChange,
    selectedColorPalette
}) => {
    
    // Obtener colores de la paleta seleccionada
    const getColorPalette = () => {
        const palettes = {
            'orange': { primary: '#fa7e17', secondary: '#ff9a3c', accent: '#e06d0f' },
            'blue': { primary: '#2563eb', secondary: '#3b82f6', accent: '#1d4ed8' },
            'green': { primary: '#10b981', secondary: '#34d399', accent: '#059669' },
            'purple': { primary: '#8b5cf6', secondary: '#a78bfa', accent: '#7c3aed' },
            'red': { primary: '#ef4444', secondary: '#f87171', accent: '#dc2626' },
            'teal': { primary: '#14b8a6', secondary: '#2dd4bf', accent: '#0d9488' },
            'pink': { primary: '#ec4899', secondary: '#f472b6', accent: '#db2777' },
            'gray': { primary: '#6b7280', secondary: '#9ca3af', accent: '#4b5563' }
        };
        return palettes[selectedColorPalette] || palettes.orange;
    };

    const colors = getColorPalette();

    return (
        <div className="pdf-content-step-container">
            
            {/* Tipo de Portada */}
            <div className="pdf-content-section">
                <h4 className="pdf-content-section-title">Tipo de Portada</h4>
                <p className="pdf-content-section-description">
                    Elige cómo quieres que se vea la primera página de tu catálogo
                </p>
                
                <div className="pdf-content-cover-options">
                    
                    {/* Opción: Banner personalizado */}
                    <div
                        className={`pdf-content-cover-card ${coverType === 'banner' ? 'selected' : ''} ${!catalog?.bannerUrl ? 'disabled' : ''}`}
                        onClick={() => catalog?.bannerUrl && onCoverTypeChange('banner')}
                    >
                        <div className="pdf-content-cover-preview banner-preview">
                            {catalog?.bannerUrl ? (
                                <img src={catalog.bannerUrl} alt="Banner" />
                            ) : (
                                <div className="pdf-content-cover-placeholder">
                                    <FontAwesomeIcon icon={faImage} />
                                    <span>Sin banner</span>
                                </div>
                            )}
                        </div>
                        <div className="pdf-content-cover-info">
                            <h5>Banner Personalizado</h5>
                            <p>Usa tu banner tal como lo subiste</p>
                        </div>
                        {coverType === 'banner' && (
                            <div className="pdf-content-cover-selected-badge">
                                <FontAwesomeIcon icon={faCheck} />
                            </div>
                        )}
                        {!catalog?.bannerUrl && (
                            <div className="pdf-content-cover-disabled-overlay">
                                <span>No disponible</span>
                            </div>
                        )}
                    </div>

                    {/* Opción: Portada generada */}
                    <div
                        className={`pdf-content-cover-card ${coverType === 'generated' ? 'selected' : ''}`}
                        onClick={() => onCoverTypeChange('generated')}
                    >
                        <div className="pdf-content-cover-preview generated-preview" style={{ background: colors.primary }}>
                            {/* Preview del diseño geométrico usando SVG */}
                            <svg 
                                viewBox="0 0 400 566" 
                                className="geometric-design-svg"
                                preserveAspectRatio="xMidYMid meet"
                            >
                                {/* Fondo */}
                                <rect width="400" height="566" fill={colors.primary} />
                                
                                {/* ========== TRIÁNGULO (BLANCO) ========== */}
                                {/* Para mover: cambia los puntos X,Y del polygon */}
                                {/* Para tamaño: ajusta la distancia entre puntos */}
                                <polygon
                                    points="350,-100 450,250 -300,-350" 
                                    fill="white"
                                    transform="rotate(-135 385 85)"
                                    
                                />

                                {/* ========== CUADRADO (BLANCO) ========== */}
                                <rect
                                />
                                
                                {/* ========== ROMBO 1:1 (COLOR SECUNDARIO) ========== */}
                                {/* x, y = posición esquina superior izquierda */}
                                {/* width, height = tamaño (mismo valor para 1:1) */}
                                {/* transform rotate(GRADOS X Y) = rotación, X Y es centro */}
                                <rect 
                                    y="150" 
                                    width="200" 
                                    height="200" 
                                    fill={colors.secondary} 
                                    transform="rotate(45 90 440)" 
                                />
                                
                                {/* ========== CONTENEDOR IMAGEN 1:1 (BLANCO CON SOMBRA) ========== */}
                                <defs>
                                    <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
                                        <feDropShadow dx="0" dy="4" stdDeviation="8" floodOpacity="0.3"/>
                                    </filter>
                                </defs>
                                {/* x, y = posición */}
                                {/* width, height = tamaño (mismo valor para 1:1) */}
                                <rect 
                                    x="130" 
                                    y="210" 
                                    width="200" 
                                    height="200" 
                                    fill="white" 
                                    filter="url(#shadow)" 
                                />
                                
                                {/* ========== TEXTO PRODUCT ========== */}
                                {/* x = posición horizontal (200 = centro) */}
                                {/* y = posición vertical */}
                                <text x="200" y="70" textAnchor="middle" fontSize="16" fontWeight="500" fill="rgba(255,255,255,0.8)" letterSpacing="4">
                                    CATÁLOGO DE
                                </text>
                                
                                {/* ========== TEXTO CATALOG ========== */}
                                <text x="200" y="95" textAnchor="middle" fontSize="28" fontWeight="700" fill="white" letterSpacing="2">
                                    PRODUCTOS
                                </text>
                                
                                {/* ========== TEXTO BRAND ========== */}
                                <text x="200" y="500" textAnchor="middle" fontSize="24" fontWeight="700" fill="white" letterSpacing="6">
                                    2026
                                </text>
                            </svg>
                            
                            {/* Icono de imagen con FontAwesome (fuera del SVG para mejor renderizado) */}
                            <div className="geometric-image-icon" style={{ 
                                position: 'absolute',
                                left: '44%',
                                top: '45%',
                                width: '25%',
                                height: '20%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                pointerEvents: 'none'
                            }}>
                                <FontAwesomeIcon icon={faImage} style={{ fontSize: '6rem', color: '#adb5bd' }} />
                            </div>
                        </div>
                        <div className="pdf-content-cover-info">
                            <h5>
                                <FontAwesomeIcon icon={faWandMagicSparkles} />
                                Portada Generada
                            </h5>
                            <p>Diseño moderno con tus colores</p>
                        </div>
                        {coverType === 'generated' && (
                            <div className="pdf-content-cover-selected-badge">
                                <FontAwesomeIcon icon={faCheck} />
                            </div>
                        )}
                    </div>

                </div>
            </div>

            {/* Página Final */}
            <div className="pdf-content-section">
                <h4 className="pdf-content-section-title">Página Final</h4>
                <p className="pdf-content-section-description">
                    Agrega una página de contacto al final del catálogo
                </p>
                
                <div className="pdf-content-toggles">
                    <label className="pdf-content-toggle">
                        <input
                            type="checkbox"
                            checked={showContactPage}
                            onChange={(e) => onShowContactPageChange(e.target.checked)}
                        />
                        <span className="pdf-content-toggle-slider"></span>
                        <span className="pdf-content-toggle-label">
                            Incluir página de contacto
                            <span className="pdf-content-toggle-hint">
                                (logo, teléfono, email, dirección)
                            </span>
                        </span>
                    </label>
                </div>
            </div>

            {/* Procesamiento de Imágenes */}
            <div className="pdf-content-section">
                <h4 className="pdf-content-section-title">
                    <FontAwesomeIcon icon={faExclamationTriangle} className="warning-icon" />
                    Procesamiento de Imágenes
                </h4>
                <p className="pdf-content-section-description">
                    Opciones avanzadas para el procesamiento de imágenes
                </p>
                
                <div className="pdf-content-warning-box">
                    <label className="pdf-content-toggle">
                        <input
                            type="checkbox"
                            checked={removeBackgrounds}
                            onChange={(e) => onRemoveBackgroundsChange(e.target.checked)}
                        />
                        <span className="pdf-content-toggle-slider"></span>
                        <span className="pdf-content-toggle-label">
                            Remover fondos de imágenes
                        </span>
                    </label>
                    <div className="pdf-content-warning-text">
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        <span>
                            Usa inteligencia artificial para remover fondos. 
                            El proceso puede tardar varios minutos (se procesarán máximo 10 imágenes por rendimiento).
                        </span>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default PDFContentStep;
